<template>
  <el-dialog
    :title="title"
    :visible="visible"
    width="72%"
    append-to-body
    @close="handleClose"
  >
    <div style="height: 360px; overflow-y: scroll">
      <el-table
        size="small"
        :data="data"
        highlight-current-row
        border
        element-loading-text="拼命加载中"
        style="width: 100%"
      >
        <el-table-column align="center" label="操作" width="120">
          <template slot-scope="scope">
            <el-button
              size="mini"
              type="danger"
              @click="handleDelete(scope.index)"
              >删除</el-button
            >
          </template>
        </el-table-column>
        <el-table-column
          sortable
          prop="moneyOrderCode"
          width="120px"
          label="票据号码"
        >
          <template slot-scope="props">
<!--            <el-tooltip-->
<!--              effect="dark"-->
<!--              :content="props.row.moneyOrderCode"-->
<!--              placement="top-start"-->
<!--            >-->
              <span
                >......<span>{{
                  props.row.moneyOrderCode.slice(-9)
                }}</span></span
              >
<!--            </el-tooltip>-->
          </template>
        </el-table-column>
        <el-table-column
          sortable
          prop="acceptorName"
          label="承兑人"
          width="140px"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          sortable
          prop="faceValue"
          label="票面金额（万）"
          show-overflow-tooltip align="center"
        >
        </el-table-column>
        <el-table-column label="出库金额" prop="splitFaceValue" align="center">
          <template slot-scope="props">
            <el-input-number
                :controls="false"
                size="small"
                v-model="props.row.splitFaceValue"
                placeholder="出库金额"
                :disabled="!props.row.disable"
            ></el-input-number>
          </template>
        </el-table-column>
        <el-table-column label="出点（%）" prop="outPercentage" align="center">
          <template slot-scope="props">
            <el-input-number
              :min="0"
              :max="100"
              :controls="false"
              size="small"
              v-model="props.row.outPercentage"
              placeholder="出点（%）"
            ></el-input-number>
          </template>
        </el-table-column>
        <el-table-column label="出库数量" prop="allCount" align="center">
          <template slot-scope="props">
            <el-input-number
                :min="0"
                :max="100"
                :controls="false"
                size="small"
                v-model="props.row.allCount"
                placeholder="出库数量"
                :disabled="props.row.disable"
            ></el-input-number>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <span slot="footer">
      <div style="display: flex; flex-direction: column">
        <div style="align-self: flex-start; margin-bottom: 10px">
          
          <span style="margin-right: 15px">
            票面金额（万）<span style="font-weight: bold">{{
              faceAllValue
            }}</span>
          </span>
          <span style="margin-right: 15px">
            票面价值（万）<span style="font-weight: bold">{{
              allOutValue
            }}</span>
          </span>
          <span>
            差值（万）<span style="font-weight: bold">{{
              allDifferencePrice
            }}</span>
          </span>
        </div>
        <div>
          报价员：
          <el-autocomplete
            size="small"
            v-model="outBidder"
            :fetch-suggestions="querySearch"
            placeholder="输入内容自动匹配报价员"
            :trigger-on-focus="false"
            @select="handleConfirmSelectSaleman($event, 'outBidder')"
          >
            <template slot-scope="{ item }">
              <div>
                {{ item.realName + "（" + item.dept.deptName + "）" }}
              </div>
            </template>
          </el-autocomplete>
          出库客户：
          <el-input
              style="width: 140px"
              size="small"
              v-model="outCustomerName"
              placeholder="出库客户"
          ></el-input>
          出库客户类型：
          <el-select v-model="outCusType" placeholder="出库客户类型："  style="width: 140px">
              <el-option
                  v-for="item in customerType"
                  :key="item.key"
                  :label="item.value"
                  :value="item.key"
              ></el-option>
            </el-select>
          业务员：
          <el-autocomplete
            size="small"
            v-model="outSalesman"
            :fetch-suggestions="querySearch"
            placeholder="输入内容自动匹配业务员"
            :trigger-on-focus="false"
            @select="handleConfirmSelectSaleman($event, 'outSalesman')"
          >
            <template slot-scope="{ item }">
              <div>
                {{ item.realName + "（" + item.dept.deptName + "）" }}
              </div>
            </template>
          </el-autocomplete>
          <el-button @click="handleClose">取 消</el-button>
          <el-button type="primary" @click="handleSubmit" v-if="submitButton">确 定</el-button>
        </div>
      </div>
    </span>
  </el-dialog>
</template>

<script>
import { updateBatchDeliverTicket } from "@/api/ticket/ticket";
import { listSalesman } from "@/api/system/user";

export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    data: {
      type: Array,
      default: () => [],
    },
    title: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      allDifferencePrice: 0,
      allOutValue: 0,
      faceAllValue: 0,
      outSalesman: null,
      outSalesmanId: null,
      outPayable: null,
      outReceivable: null,
      outBidder: null,
      outBidderId: null,
      outCustomerName: null,
      submitButton: true,
      outCusType: null,
      customerType:[
        {"key":"C_1","value":"公司客户"},
        {"key":"C_2","value":"中介"},
        {"key":"C_3","value":"终端客户"},
      ]
    };
  },
  methods: {
    handleDelete(index) {
      this.data.splice(index, 1);
    },
    querySearch(name, call) {
      listSalesman(name)
        .then((list) => {
          call(list);
          if (list.length <= 0) {
            this.$message.warning("不存在该业务员");
          }
        })
        .catch(this.$message.error);
    },
    handleConfirmSelectSaleman(data, type) {
      if (data) {
        if (type === "outSalesman") {
          this.outSalesman = data.realName;
          this.outSalesmanId = data.id;
        }
        if (type === "outBidder") {
          this.outBidder = data.realName;
          this.outBidderId = data.id;
        }
      }
    },
    handleSubmit() {
      if (this.data.length) {
        if (!this.outSalesman) {
          this.$message.warning("业务员是必填属性");
          return;
        }
        if (!this.outCustomerName) {
          this.$message.warning("出库客户是必填属性");
          return;
        }
         if (!this.outCusType) {
          this.$message.warning("出库客户类型是必填属性");
          return;
        }
        for (let d of this.data) {
          if (d.splitFaceValue <=0 ) {
            this.$message.warning("票据出库金额为0");
            return;
          }
          if (d.splitFaceValue > d.faceValue) {
                this.$message.warning("票据出库金额超过票面金额");
                return;
          }
      }

        updateBatchDeliverTicket({
          orderList: this.data.map((item) => {
            item.outSalesman = this.outSalesman;
            item.outSalesmanId = this.outSalesmanId;
            item.outCustomerName = this.outCustomerName
            item.outBidder = this.outBidder;
            item.outBidderId = this.outBidderId;
            item.outCusType = this.outCusType
            return item;
          }),
          outPayable: this.outPayable,
          outReceivable: this.outReceivable,
        })
          .then((data) => {
            const { faceCount, allDifferencePrice, allOutValue, faceAllValue } =
              data;
            this.allDifferencePrice = allDifferencePrice;
            this.allOutValue = allOutValue;
            this.faceAllValue = faceAllValue;
            this.submitButton = false;
            this.$message.success("操作成功");
          })
          .catch(this.$message.warning);
      } else {
        this.$message.warning("不存在编辑数据，无法批量更新！");
      }
    },
    handleClose() {
      this.$emit("update:visible", false);
      this.$emit("confirm");
      this.allDifferencePrice = 0;
      this.allOutValue = 0;
      this.faceAllValue = 0;
      this.outSalesman = null;
      this.outSalesmanId = null;
      this.outPayable = null;
      this.outReceivable = null;
      this.outBidder =null;
      this.outBidderId = null;
      this.outCustomerName = null;
       this.outCusType = null
      this.submitButton = true;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/ticket/ticket-deliver/batch.vue